import { render, staticRenderFns, recyclableRender, components } from "./webView.vue?vue&type=template&id=7447d33a&scoped=true&"
var renderjs
import script from "./webView.vue?vue&type=script&lang=js&"
export * from "./webView.vue?vue&type=script&lang=js&"
import style0 from "./webView.vue?vue&type=style&index=0&id=7447d33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7447d33a",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/webView/webView.vue"
export default component.exports